import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/components/WorkExperience.css';

/**
 * Vertical career timeline.
 *
 * Replaces the old static PNG (which couldn't be updated easily and
 * was rendered at two resolutions for mobile/desktop).
 *
 * To add or update an entry: edit the TIMELINE_ITEMS array. Order is
 * oldest → newest (top to bottom) — preserves the journey narrative.
 *
 * Item shape:
 *   period — display string for the date range (e.g. '2023 — 2025')
 *   title  — role / degree
 *   org    — company / institution
 *   type   — 'education' | 'work' | 'side' (drives the dot style)
 *   link   — optional internal route to a case study (e.g. '/schrodinger')
 */

// Order: newest at the top (most recent role first). Recruiters skim
// — they want to see the latest first.
const TIMELINE_ITEMS = [
  {
    period: '2025 — 2026',
    title: 'Associate Product Designer',
    org: "Bally's Interactive",
    type: 'work',
    link: '/ballys',
  },
  {
    period: '2023 — 2025',
    title: 'UX Designer',
    org: 'Schrödinger',
    type: 'work',
    link: '/schrodinger',
  },
  {
    period: '2022 — 2023',
    title: 'UX Researcher & Designer',
    org: 'Arizona State University',
    type: 'work',
  },
  {
    period: '2022',
    title: 'UX Design Intern',
    org: 'OurDate',
    type: 'work',
    link: '/ourdate',
  },
  {
    period: '2021 — 2023',
    title: "Master's in Human-Computer Interaction",
    org: 'Arizona State University',
    type: 'education',
  },
  {
    period: '2020 — 2021',
    title: 'Front-End Developer',
    org: 'Deloitte',
    type: 'work',
  },
  {
    period: '2019 — 2020',
    title: 'Content Writer',
    org: 'Made4U',
    type: 'side',
  },
  {
    period: '2019',
    title: 'Creative Writer',
    org: 'PV Global Foundation',
    type: 'side',
  },
  {
    period: '2016 — 2020',
    title: 'B.Tech in Electronics & Communication',
    org: 'VNRVJIET, Hyderabad',
    type: 'education',
  },
];

const TYPE_LABEL = {
  education: 'Education',
  work: 'Work',
  side: 'Side gig',
};

const WorkExperience = () => {
  return (
    <div className="timeline">
      <ol className="timeline__list">
        {TIMELINE_ITEMS.map((item, i) => {
          const content = (
            <div className="timeline__content">
              <div className="timeline__meta">
                <span className="timeline__period">{item.period}</span>
                <span className={`timeline__tag timeline__tag--${item.type}`}>
                  {TYPE_LABEL[item.type]}
                </span>
              </div>
              <h3 className="timeline__title">{item.title}</h3>
              <p className="timeline__org">{item.org}</p>
              {item.link && (
                <span className="timeline__link-hint">View case study →</span>
              )}
            </div>
          );

          // The dot is rendered OUTSIDE the link wrapper so the link's
          // hover transform (translateX) only nudges the content — the
          // dot stays anchored on the centre line.
          return (
            <li
              key={i}
              className={`timeline__item ${item.link ? 'timeline__item--linked' : ''}`}
            >
              <span className={`timeline__dot timeline__dot--${item.type}`} aria-hidden="true" />
              {item.link ? (
                <Link to={item.link} className="timeline__link">
                  {content}
                </Link>
              ) : (
                content
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default WorkExperience;
